import { defineMessages } from 'react-intl';

import type {
  DisplayableMarketingPreference,
  DisplayablePreference,
} from './types.ts';

export const notificationTitles = defineMessages<
  | DisplayablePreference
  | DisplayableMarketingPreference
  | 'max_push_notifications'
  | 'enable_push_notifications'
>({
  announcement: {
    defaultMessage: 'Announcement',
  },
  card_subscription: {
    defaultMessage: 'Card subscription',
  },
  player_subscription: {
    defaultMessage: 'Player subscription',
  },
  higher_bid: {
    defaultMessage: 'Higher bid',
  },
  card_sold: {
    defaultMessage: 'Card sold',
  },
  card_not_sold: {
    defaultMessage: 'Card not sold',
  },
  card_revealable: {
    defaultMessage: 'Card revealable',
  },
  card_withdrawal_started: {
    defaultMessage: 'Card withdrawal started',
  },
  card_withdrawn: {
    defaultMessage: 'Card withdrawn',
  },
  card_bought: {
    defaultMessage: 'Card bought',
  },
  market_credit_expiring_soon: {
    defaultMessage: 'Market credit expiring',
  },
  offer_received: {
    defaultMessage: 'Offer received',
  },
  offer_accepted: {
    defaultMessage: 'Offer accepted',
  },
  offer_rejected: {
    defaultMessage: 'Offer rejected',
  },
  offer_cancelled: {
    defaultMessage: 'Offer canceled',
  },
  offer_withdrawn: {
    defaultMessage: 'Offer withdrawn',
  },
  offer_countered: {
    defaultMessage: 'Counter offer received',
  },
  so5_lineup_too_powerful: {
    defaultMessage: 'So5 lineup too powerful',
  },
  so5_lineup_invalid: {
    defaultMessage: 'Lineup invalid',
  },
  appearance_destroyed: {
    defaultMessage: 'Appearance destroyed',
  },
  new_results: {
    defaultMessage: 'New results',
  },
  referrer_reward_ready_to_claim: {
    defaultMessage: 'Referrer reward ready to claim',
  },
  referee_reward_ready_to_claim: {
    defaultMessage: 'Referee reward ready to claim',
  },
  gameplay_tips: {
    defaultMessage: 'Gameplay Tips',
  },
  reminders: {
    defaultMessage: 'Reminders',
  },
  news: {
    defaultMessage: 'News',
  },
  max_push_notifications: {
    defaultMessage: 'Max push notifications',
  },
  enable_push_notifications: {
    defaultMessage: 'Enable push notifications',
  },
  push_notifications_decisive_action: {
    defaultMessage: 'Decisive actions',
  },
});

export const notificationSubtitles = defineMessages<
  | DisplayablePreference
  | DisplayableMarketingPreference
  | 'max_push_notifications'
  | 'enable_push_notifications'
>({
  announcement: {
    defaultMessage: 'Sorare announcements',
  },
  card_subscription: {
    defaultMessage:
      "Received when a Card you're subscribed to is put on Auction.",
  },
  player_subscription: {
    defaultMessage:
      "Received when a card of a player you're subscribed to is put on auction.",
  },
  higher_bid: {
    defaultMessage: 'Received when a Manager sets a higher bid than your own.',
  },
  card_sold: {
    defaultMessage: 'Received when you have successfully sold a Card.',
  },
  card_not_sold: {
    defaultMessage:
      'Received when one of your sales expires without any buyer.',
  },
  card_withdrawal_started: {
    defaultMessage: 'Received when you initiate a card withdrawal.',
  },
  card_revealable: {
    defaultMessage: 'Received when a card becomes revealable.',
  },
  card_withdrawn: {
    defaultMessage:
      'Received when a card withdrawal is successfully completed.',
  },
  card_bought: {
    defaultMessage: 'Received when you have successfully bought a card.',
  },
  market_credit_expiring_soon: {
    defaultMessage: 'Received when your market credit is about to expire',
  },
  offer_received: {
    defaultMessage: 'Received when a Manager has sent an offer to you.',
  },
  offer_countered: {
    defaultMessage: 'Received when someone has made a counter offer to you.',
  },
  offer_accepted: {
    defaultMessage: 'Received when one of your offers has been accepted.',
  },
  offer_rejected: {
    defaultMessage:
      'Received when a Manager you made an offer to rejects your offer.',
  },
  offer_cancelled: {
    defaultMessage: 'Received when one of your offers has been canceled.',
  },
  offer_withdrawn: {
    defaultMessage:
      'Received when one of the offers you received has been cancelled.',
  },
  so5_lineup_too_powerful: {
    defaultMessage:
      'Received when one of your lineup exceeds the leaderboard power cap.',
  },
  so5_lineup_invalid: {
    defaultMessage:
      'Received when one of your submitted lineup becomes invalid.',
  },
  appearance_destroyed: {
    defaultMessage: 'Received when your card is removed from a lineup.',
  },
  new_results: {
    defaultMessage:
      'Received when the results of a Tournament have been published.',
  },
  gameplay_tips: {
    defaultMessage:
      'Received when onboarding into Football, NBA or MLB to better understand Sorare Fantasy Game.',
  },
  referrer_reward_ready_to_claim: {
    defaultMessage: 'Received when you have a referrer reward ready to claim.',
  },
  referee_reward_ready_to_claim: {
    defaultMessage: 'Received when you have a referee reward ready to claim.',
  },
  reminders: {
    defaultMessage:
      'Received when you forgot to compose a team or claim rewards.',
  },
  news: {
    defaultMessage:
      'Received when Sorare has announcements to share or monthly updates like our newsletter, The Snapshot.',
  },
  max_push_notifications: {
    defaultMessage: 'Set your maximum number of push notifications per day.',
  },
  enable_push_notifications: {
    defaultMessage: 'Receive push notifications on this device.',
  },
  push_notifications_decisive_action: {
    defaultMessage:
      'Received when a player in your lineup realizes a decisive action.',
  },
});
